import {defineMessages} from 'react-intl';

export default defineMessages({
    info: {
        id: 'app.impersonationBanner.info',
        defaultMessage: 'You are now viewing the page as {userName}.'
    },
    endImpersonation: {
        id: 'app.impersonationBanner.endImpersonation',
        defaultMessage: 'Return to normal mode.'
    }
});
